import {Injectable} from '@angular/core';
import {Duration} from 'luxon';
import {AssertionUtils} from '../../../common/utils/assertion-utils';
import {ScheduleItem} from '../schedule-item.interface';
import {ScheduleItemWithWidth} from './schedule-item-with-width.interface';

@Injectable({
  providedIn: 'root'
})
export class TimelineRowService {
  private newScheduleItems: ScheduleItemWithWidth[];
  private readonly BOX_WIDTH = 48;

  public getScheduleItems(scheduleItems: ScheduleItem[], startTime: Duration, endTime: Duration): ScheduleItemWithWidth[] {
    this.newScheduleItems = [];

    if (scheduleItems.length === 0) {
      this.pushDataToArray(this.calculateWidth(startTime, endTime), null);
    } else {
      this.pushMultiDataToArray(scheduleItems, startTime, endTime);
    }

    return this.newScheduleItems;
  }

  public calculateWidth(timeOne: Duration, timeTwo: Duration, removeGap: boolean = true): number | null {
    const minutes = timeTwo.minus(timeOne).as('minutes');
    return this.calculateWidthFromMinutes(minutes, removeGap);
  }

  public calculateWidthFromMinutes(minutes: number, removeGap: boolean = true): number {
    if (minutes <= 0) {
      return null;
    }
    return (minutes / 60) * this.BOX_WIDTH - (removeGap ? 1 : 0);
  }

  private pushMultiDataToArray(scheduleItems: ScheduleItem[], startTime: Duration, endTime: Duration): void {
    for (let index = 0; index < scheduleItems.length; index++) {
      const element = scheduleItems[index];
      const isLastElement = index === scheduleItems.length - 1;
      const nextElement = scheduleItems[index + 1];

      if (index === 0) {
        this.pushDataToArray(this.calculateWidth(startTime, element.startTime), null);
      }
      if (!AssertionUtils.isNullOrUndefined(element.startTime) && !AssertionUtils.isNullOrUndefined(element.endTime)) {
        this.pushDataToArray(this.calculateWidth(element.startTime, element.endTime), element);
      }
      if (!AssertionUtils.isNullOrUndefined(nextElement) && this.checkGapBetweenSchedules(element.endTime, nextElement.startTime)) {
        this.pushDataToArray(this.calculateWidth(element.endTime, nextElement.startTime), null);
      }
      if (isLastElement) {
        this.pushDataToArray(this.calculateWidth(element.endTime, endTime), null);
      }
    }
  }

  private pushDataToArray(width: number, schedule: ScheduleItem): void {
    this.newScheduleItems.push({
      width: width,
      scheduleItem: schedule
    });
  }

  private checkGapBetweenSchedules(endTime: Duration, startTime: Duration): boolean {
    return !endTime.equals(startTime);
  }
}
